// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"1d0787d3","556":"12c0a99f"}[chunkId] + ".chunk.js";
};